import { render } from "./EmailIcon.vue?vue&type=template&id=eafe09ea"
import script from "./EmailIcon.vue?vue&type=script&lang=js"
export * from "./EmailIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__